import React, { Fragment } from 'react';

const TagsList = (props) => {
  return (
    <Fragment>
      {props.tags.map((tag, index) => (
        <Fragment key={index.toString()}>
          <div className="badge badge-primary">
            {tag.name}
          </div>
        </Fragment>
      ))}
    </Fragment>
  );
};

export default TagsList;
